// import external dependencies
import 'jquery';
import 'jquery-asPieProgress/dist/jquery-asPieProgress';
import 'inputmask/dist/jquery.inputmask';
import 'inputmask/dist/inputmask';
import 'select2/dist/js/select2';
// import 'stripe/lib/stripe';

// Import everything from autoload
import './autoload/_bootstrap.js'
import './util/croppie.js';
import './stepper/stepper-functions';
import './routes/quiz-questions';
import './routes/preloader-modal';
import './routes/user-details-form';
import './routes/brokers';
import './stepper/stepper';
import './routes/login-forgot-modal';
import './routes/profile';

import './util/gclid';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js